import { useSelector } from 'react-redux';

import { isLoggedInSelector } from 'reducers/user';

export const useIsLoggedIn = () => useSelector(isLoggedInSelector);
